import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CommonModule } from '@angular/common';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ViajeDTO } from '../../../dtos/viaje.dto';
import { ViajeService } from '../../services/viaje.service';
import { ToastrService } from 'ngx-toastr';
import { EventService } from '../../services/event.service';

@Component({
  selector: 'app-modal-confirmar-viaje',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal-confirmar-viaje.component.html',
  styleUrl: './modal-confirmar-viaje.component.scss'
})
export class ModalConfirmarViajeComponent implements OnInit {
  viaje: ViajeDTO | null = null;
  enviando: boolean = false;

  constructor(
    public bsModalRef: BsModalRef,
    private viajeService: ViajeService,
    private eventService: EventService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    // The viaje data is passed from the viaje component via initialState
    // If we need to get additional data, we could do it here
    if (this.viaje) {
      // We could load additional data if needed
      // For example: this.viajeService.getViajeDetails(this.viaje.id)
    }
  }

  close(): void {
    this.bsModalRef.hide();
  }

  confirmarViaje(imprimir : boolean = false): void {
    if (this.viaje && this.viaje.conductor && this.viaje.movil) {
      this.enviando = true;
      // Call the service to confirm the viaje
      this.viajeService.confirmarConductorMovil(
        this.viaje.uuid,
        this.viaje.conductor.uuid,
        this.viaje.movil.uuid
      ).subscribe({
        next: (response) => {
          if (response.success) {
            console.log('Viaje confirmado exitosamente');

            // Update the confirmado property
            if (this.viaje) {
              this.viaje.confirmado = true;
            }

            // Store the selected viaje in the service
            this.viajeService.setViajeSeleccionado(this.viaje);

            // Publish event to notify that a viaje has been confirmed
            // This will trigger a refresh in the despachador component
            this.eventService.publish('VIAJE_CONFIRMADO_EVENT', {viaje : this.viaje, imprimir : imprimir});

            this.enviando = false;
            // Close the modal
            this.close();
          } else {
            console.error('Error al confirmar viaje:', response.msg);
            this.enviando = false;
            this.toastr.warning(response.msg, 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
          }
        },
        error: (error) => {
          console.error('Error al confirmar viaje:', error);
          this.enviando = false;
          this.toastr.error((error.error?.msg || '') + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
        }
      });
    }
  }
}
